import Base from 'ui-theme/js/_base';
import utils, {Utils} from './utils/index';
export default class PNASBase extends Base {

    private _elmRef: HTMLElement;
    
    constructor() {
        super();
    }

    set ElmRef(elmRef) {
        this._elmRef = elmRef;
    }
    
    get utils(): Utils {
        return utils;
    }

    get ElmRef() {
        return this._elmRef;
    }


    cloneElm(elm): HTMLElement {
        return $(elm).clone(true, true)[0];
    } 

    queryElm(selector: string, list?: boolean, refElm?: HTMLElement): HTMLElement | NodeListOf<HTMLElement> | null {
        refElm = refElm || window.document as any;
        if(list)
            return refElm.querySelectorAll(selector);
        return refElm.querySelector<HTMLElement>(selector);
    }

    showWarn(message): void {
        console.warn(message);
    }

    generateNumericId(): string {
        return (Math.random() * Math.pow(10, 7)).toFixed().toString();;
    }

    wait(duration: number): Promise<void> {
        return new Promise(resolve =>  setTimeout(() => resolve(), duration));
    }

    async animateClassChange(
        elm: HTMLElement, 
        className: string, 
        action: 'toggle' | 'add' | 'remove' = 'toggle', 
        duration?: number
        ): Promise<HTMLElement> {
        if(duration) {
            elm.style.transition = `all ${duration/1000}s`;
            await this.wait(100);
        }
        elm.classList[action](className);
        if(duration)
            await this.wait(duration);
        elm.style.transition = `none`;
        return elm;
    } 

    subscribeToEvent(eventName: string, callbackOr: ((any) => void)|string, callback?: (any) => void): void {
        /* wrapper to jquery functionality should be replaced once you have the time */
        const documentElm = $(document);
        documentElm.on.apply(documentElm, arguments);
    }

    triggerEvent(name: string): void {
        /* wrapper to jquery functionality should be replaced once you have the time */
        const documentElm = $(document);
        documentElm.trigger.apply(documentElm, arguments);
    }

    toggleLockScroll(): void {
        const bodyElm = this.queryElm('body') as HTMLElement;
        bodyElm.classList.toggle('scroll-locked');
    }
}

